<p-splitButton label="Update Status" [model]="items" 
    styleClass="p-button-raised p-button-text mr-2 mb-2">
</p-splitButton>